

import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { PaybookService } from './paybook.service';

@Component({
  selector: 'app-paybook',
  template: `
     <div class="p-2" >
      <div class="progress" *ngIf="isLoading" style="height: 5px; margin: 5px 0; border-radius: 5px;">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-secondary w-100"></div>
      </div>
      <h3 *ngIf="bank.length <= 0" class="text-center text-uppercase text-info p-2">Seleccione un Banco</h3>
      <div *ngIf="bank.length > 0" id="{{ widgetID }}" style="max-width: 300px; margin: 0 auto 8px auto; box-shadow: 0 0 10px #999;"></div>
      <div class="alert alert-danger d-flex align-items-center justify-content-between" role="alert" *ngIf="tratos > 0">
        <strong>Reconectando, espere por favor...</strong>
        <small>Nº de Intentos para conectase {{ tratos }}</small>
      </div>
      <div class="alert alert-info " role="alert">
        <i class="fa fa-shield" style="font-size: 1em;"></i>
        <small>La información enviada por esta página sera encriptada para su seguridad.</small>
      </div>
      <div class="d-flex align-items-between justify-content-between">
        <button (click)="login()" class="btn btn-default"><i class="fa fa-repeat"></i>  Recargar </button>
        <strong class="bnt-danger"> {{ error }}</strong>
        <button (click)="data()" class="btn btn-info"><i class="fa fa-floppy-o"></i> Importar </button>
        <button (click)="cerrar()" class="btn btn-danger"><i class="fa fa-close"></i> Cerrar conexión </button>
      </div>
     </div>
  `
  //<button (click)="check()" class="btn btn-info"><i class="fa fa-search"></i>  </button>
})
export class PaybookComponent implements OnInit, OnChanges {

  transactions

  @Input()
  widgetID: string;
  @Input()
  bank: string;
  @Input()
  user: string;
  @Output()
  onClose = new EventEmitter<any>();

  tratos = 0;
  error = ''
  isLoading = false;


  constructor(private paybookService: PaybookService) {
    this.paybookService.subject.subscribe(data => {
      if (data == 'error') {
        this.onClose.emit([]);
      } else {
        //console.log('desde componente', data);
        this.transactions = data;
        this.onClose.emit(this.transactions);
      }
    })

    this.paybookService.errors.subscribe(error => {
      this.isLoading = false;
      this.tratos += 1;
      this.login();
    })
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.bank) {
      this.login();
    }
  }

  login() {
    if (this.bank.length <= 0) {
      return;
    }
    this.isLoading = true;
    this.error = ''
    setTimeout(() => {
      this.paybookService.userExist(this.user, this.widgetID, this.bank)
        .then(data => {
          this.tratos = 0;
          this.isLoading = false;
        })
    }, 500);
  }

  data() {
    this.paybookService.getTransactions();
      

  }

  cerrar()
  {
    this.paybookService.closeConection();
  }

  check()
  {
    this.paybookService.getUsers();
  }
}

/*
56cf5728784806f72b8b456e Banorte Personal
56cf5728784806f72b8b456b Personal
56de2130784806d7028b4589 AfirmeNet
56cf5728784806f72b8b456c BancaNet Personal
56cf5728784806f72b8b456f CIEC
56cf5728784806f72b8b456d eBanRegio
56fd304c78480623038b457b Banorte en su empresa
571175467848062d698b4568 BancaNet Empresarial
5719a71a7848060f038b4568 Banca Personal
57239fae78480601038b4567 Corporativo
57292023784806af038b458b Banco Azteca
572930c4784806060f8b456b American Express
5731fb37784806a6118b4571 SuperNET Particulares
5739cc3b7848066b028b4573 ScotiaWeb
57239fae78480601038b4568 Empresas
574f16977848067c038b4593 InbuRed
5760214578480648038b4584 Invex
5761abf97848065b038b4569 BanCoppel Personal
5777e4bbc320d546ba6e014d Inbursa Personal
57893e15784806f2218b457d Multivanet
57accfcd784806f4038b4567 IXE empresa
57d1bccd784806b9488b456b Banco Famsa
57ec3757784806dc038b4567 Liverpool
57f6dd8c78480602048b4567 Santander Empresas
57fed73d7848060b038b4586 CFE
582a05fb78480655628b45a1 Movistar
580fa37978480600038b4571 Telcel
57ffc01a7848060a038b45b1 Telmex
582f8a21784806eb348b4581 AT&T
583db66378480635468b456b BanBajio Personas
58543125784806c3298b4572 SAT Declara
58db325f056f293bed3ebfb1 Scotiabank Empresas
5903d9c5056f2905e37d4951 Banco Azteca Empresas
*/



// WEBPACK FOOTER //
// ./src/app/paybook/paybook.component.ts